/**
 * Simple RetryManager with 1-second fixed delay
 */
class RetryManager {
  constructor() {
    this.socket = null;
    this.retryDelay = 1000; // 1 second
    this.maxRetries = 3;
  }

  setSocket(socket) {
    this.socket = socket;
  }

  isSocketReady() {
    return this.socket && this.socket.readyState === WebSocket.OPEN;
  }

  async send(message) {
    let lastError = null;

    for (let attempt = 0; attempt <= this.maxRetries; attempt++) {
      try {
        // Wait 1 second before retry attempts (not on first attempt)
        if (attempt > 0) {
          await this._sleep(this.retryDelay);
          console.log(`Retry attempt ${attempt}/${this.maxRetries}`);
        }

        // Try to send
        const result = await this._trySend(message);

        if (result.success) {
          if (attempt > 0) {
            console.log(`Message sent after ${attempt} retries`);
          }
          return { success: true };
        }

        lastError = result.error;
      } catch (error) {
        lastError = error;
      }
    }

    // All retries failed
    console.error(`Failed to send message after ${this.maxRetries} retries:`, lastError);
    return { success: false, error: lastError };
  }

  async _trySend(message) {
    if (!this.isSocketReady()) {
      return { success: false, error: 'Socket not ready' };
    }

    try {
      this.socket.send(JSON.stringify(message));
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

export default RetryManager;
